import script from "./MemeControl.vue?vue&type=script&setup=true&lang=js"
export * from "./MemeControl.vue?vue&type=script&setup=true&lang=js"

import "./MemeControl.vue?vue&type=style&index=0&id=051d58c0&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051d58c0"]])

export default __exports__